export const ENV = {
    BASE_URL: '/',
    API_MODE: 'api',
//API_URL: 'http://3.113.215.144/api/admin',
//APP_API_URL: 'http://3.113.215.144/api/',
	API_URL: 'https://api.peer-less.net/api/admin',
	APP_API_URL: 'https://api.peer-less.net/api/',

    LOCALE : 'ja'
}
